import React from "react";

const ToolBarMenu = (props) => {

    const {
        itemsToolBarMenu,
        onHandleToolBarMenu
    } = props;

    return (
        <div className="table-menu">
            {itemsToolBarMenu.map((el, i) => {
                return (
                    <div onClick={() => onHandleToolBarMenu(el.value)} key={i} className="table-menu__item">
                        <img className="table-menu__item-icon" src={el.icon} alt={'icon'}/>
                        <p className={el.value === 'Annulate' || el.value === 'Confirm annulate' ? "table-menu__item-name-annulate" : "table-menu__item-name"}>{el.value}</p>
                    </div>
                )
            })}
        </div>
    )
}
export default ToolBarMenu;